import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SprekerService } from '../spreker.service';

@Component({
  selector: 'app-speaker',
  templateUrl: './speaker.component.html',
  styleUrls: ['./speaker.component.css']
})
export class SpeakerComponent implements OnInit {

  name: string;
  spreker;
  sprekers: Array<object>;

  constructor(private route: ActivatedRoute, private sprekerService: SprekerService, private router: Router) {
    this.sprekers = sprekerService.getSprekers();
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.name = params.get('name'); // get the name from the url
      console.log(this.name);
      this.spreker = this.sprekerService.getSprekerByName(this.name);
      console.log(this.spreker);
    });
  }

}
